import { ThemeOptions } from "@material-ui/core/styles";

import * as colors from "../../colors";

import yellowColorPalette from "../palettes/light_yellowPalette";

export const yellowOptions = {
	typography: {
		allVariants: {
			color: colors.basic[800],
			fontFamily: "var(--openSans)"
		},
		h1: {
			fontSize: 22,
			fontFamily: "var(--poppins)",
			fontWeight: 900,
			color: colors.yellow[400]
		},
		h2: {
			fontSize: 18
		},
		h3: {
			fontSize: 16
		}
	},
	overrides: {
		MuiList: {
			root: {
				backgroundColor: colors.basic[200]
			}
		},
		MuiStepper: {
			root: {
				background: "transparent"
			}
		},
		MuiStepLabel: {
			root: {
				color: colors.basic[100],
				fontWeight: 600,
				"& .MuiStepLabel-label.MuiStepLabel-active": {
					fontWeight: 600,
					color: colors.basic[100]
				},
				"& .MuiStepLabel-label.MuiStepLabel-completed": {
					fontWeight: 600,
					color: colors.basic[100]
				}
			},
			completed: {
				color: colors.basic[100],
				opacity: 0.3,
				fontWeight: 600,
				fontSize: "15px"
			},
			active: {
				color: colors.basic[100],
				opacity: 0.9,
				fontWeight: 600,
				fontSize: "15px"
			},
			label: {
				color: colors.basic[100],
				opacity: 0.4,
				fontWeight: 600,
				fontSize: "15px"
			}
		},
		MuiSelect: {
			root: {
				backgroundColor: colors.basic[100],
				borderRadius: "4px"
			},
			filled: {
				color: colors.basic[1150]
			}
		},
		MuiFilledInput: {
			root: {
				backgroundColor: colors.basic[100],
				borderRadius: "4px",
				"&:hover input:-webkit-autofill": {
					"-webkit-box-shadow": `0 0 0 5000px ${colors.basic[200]} inset`
				}
			},
			input: {
				"&:-webkit-autofill": {
					WebkitBoxShadow: `0 0 0 1000px ${colors.basic[200]} inset`,
					borderTopRightRadius: 0,
					borderTopLeftRadius: 0
				},
				color: colors.basic[1400]
			}
		},
		MuiInputLabel: {
			root: {
				color: colors.yellow[400]
			}
		},
		MuiCard: {
			root: {
				background: colors.basic[100],
				padding: "30px",
				width: "100%",
				borderRadius: "4px"
			}
		},
		MuiButton: {
			root: {
				fontFamily: "var(--poppins)",
				textTransform: "none",
				padding: "10px 20px",
				fontSize: "14px"
			},
			text: {
				color: "hsl(0,0%,69%)" //todo: add into the colors set
			},
			containedPrimary: {
				fontWeight: 600
			},
			containedSecondary: {
				fontWeight: 600,
				"&:hover": {
					backgroundColor: colors.basic[900]
				}
			}
			// containedPrimary: {
			// 	borderRadius: 4,
			// 	backgroundColor: "#d5af34",
			// 	"&:hover": {
			// 		backgroundColor: "#f4c93f"
			// 	}
			// }
		},
		MuiSvgIcon: {
			root: {
				"& #path_primary": {
					fill: "hsl(42, 100%, 49%)",
					"stop-color": "hsl(42, 100%, 49%)"
				},
				"& #path_secondary": {
					fill: "hsl(42, 97%, 75%)",
					"stop-color": "hsl(42, 97%, 75%)"
				}
			}
		},
		MuiCheckbox: {
			root: {
				"&$checked": {
					color: colors.primary[500]
				}
			}
		},
		MuiRadio: {
			root: {
				"&$checked": {
					color: colors.primary[500]
				}
			}
		},
		MuiPaginationItem: {
			root: {
				"&[aria-current='true']": {
					color: colors.basic[100],
					background: `${colors.yellow[400]} !important`
				},
				"&:hover": {
					color: colors.basic[200],
					backgroundColor: `${colors.yellow[200]} !important`
				}
			}
		},
		MuiTableCell: {
			root: {
				borderBottomColor: colors.basic[300]
			}
		}
	},
	palette: {
		...yellowColorPalette
	}
} as ThemeOptions;
